// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "dropdown-module--base-text-alt--global--005a7";
export var baseTextGlobal = "dropdown-module--base-text--global--cbd98";
export var blockSpacing100 = "dropdown-module--block-spacing-100--b7598";
export var blockSpacing50 = "dropdown-module--block-spacing-50--10bb1";
export var blockVPadding100 = "dropdown-module--block-v-padding-100--2826b";
export var blockVPadding50 = "dropdown-module--block-v-padding-50--0d010";
export var captionTextGlobal = "dropdown-module--caption-text--global--245eb";
export var cmsRenderedContentGlobal = "dropdown-module--cms-rendered-content--global--19a52";
export var container = "dropdown-module--container--f5b68";
export var defaultHSpacingGlobal = "dropdown-module--default-h-spacing--global--cf89b";
export var fadeInAnimation = "dropdown-module--fadeInAnimation--accec";
export var fadeInOnLoadGlobal = "dropdown-module--fade-in-on-load--global--1d45d";
export var fullHeightGlobal = "dropdown-module--full-height--global--92859";
export var fullHeightOmittingNavGlobal = "dropdown-module--full-height-omitting-nav--global--2cdda";
export var headingTextGlobal = "dropdown-module--heading-text--global--89091";
export var ingressTextGlobal = "dropdown-module--ingress-text--global--75503";
export var linkColorChangeTransitionGlobal = "dropdown-module--link-color-change-transition--global--eaa56";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "dropdown-module--page-heading-text--global--f4266";
export var paragraphTextGlobal = "dropdown-module--paragraph-text--global--2ec1b";
export var select = "dropdown-module--select--1e84b";
export var subheadingTextGlobal = "dropdown-module--subheading-text--global--6ff8e";